/* tslint:disable */
/* eslint-disable */
/**
 * Qarma Inspect
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 114.0.1 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Access features applicable to `Supplier`.
 * 
 * The features represent the access permissions that the calling user has on the given
 * `Suppler`.
 * @export
 * @enum {string}
 */
export enum SupplierFeaturesDto {
    List = 'list',
    Read = 'read',
    Modify = 'modify',
    ApproveSupplierDocuments = 'approve_supplier_documents',
    Delete = 'delete',
    SupplierDashboard = 'supplier_dashboard'
}

export function SupplierFeaturesDtoFromJSON(json: any): SupplierFeaturesDto {
    return SupplierFeaturesDtoFromJSONTyped(json, false);
}

export function SupplierFeaturesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierFeaturesDto {
    return json as SupplierFeaturesDto;
}

export function SupplierFeaturesDtoToJSON(value?: SupplierFeaturesDto | null): any {
    return value as any;
}

